import { isBefore, isValid } from 'date-fns'

import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'
import type { Organization } from '@modules-deprecated/app/organization/types/organization'

import { quickStartEligibleFromDate } from '../constants/quickStartEligibleFromDate'

interface IsQuickStartEligibleOptions {
  organization?: Organization
}

const quickStartExcludedPlans = new Set([
  SubscriptionPlan.EBPFree,
  SubscriptionPlan.IToolFree,
  SubscriptionPlan.QuadraFree,
])

/**
 * Eligibility requirements (all must be true):
 * - Organization was created on/after the Quick Start release date
 * - Organization is not on a partner-specific plan (quadra_free, ebp_free, itool_free)
 */
export const isQuickStartEligible = ({ organization }: IsQuickStartEligibleOptions): boolean => {
  if (!organization?.createdTime || quickStartExcludedPlans.has(organization.subscriptionProductPlan)) {
    return false
  }

  const createdTime = new Date(organization.createdTime)

  return isValid(createdTime) && !isBefore(createdTime, quickStartEligibleFromDate)
}
